import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditArbreComponent } from './edit-arbre/edit-arbre.component';
import { TreeService } from 'src/app/services/http/tree/tree.service';


@Component({
  selector: 'app-arbre-management',
  templateUrl: './arbre-management.component.html',
  styleUrls: ['./arbre-management.component.scss']
})

/**
 * Main Component to manage the failure tree.
 * 
 */
export class ArbreManagementComponent implements OnInit {
  public showAll: boolean = false;

  constructor(public dialog : MatDialog, public treeService: TreeService) { }

  /** First node of the Tree, aka root. 
   * Has to be 'any' type so we can set it to undefined, forcing the ui to refresh.
   * Real type is 'ArbreComposant' 
   */
  public rootOfTree!:  any;

  async ngOnInit(): Promise<void> {
    this.updateTree();
  }

 
  /**
   * Force to get the latest tree, refreshing ui
   * This method is bound to (reloadEvent) Output of ArbreComponent
   */
  async updateTree(){
        /** Force detection that zones and all sub components have changed */
        this.rootOfTree = undefined;
        this.rootOfTree = await this.treeService.getComposant( 1 );
  }
  
  /** Edit root of tree */
  editMachine(){
    const data = {
      composant : this.rootOfTree,
      edition: true,
      iamroot: true
    };

    this.openDialog(data);
  }

  /** Create a new element */
  newElement(){
    const data =  {
      edition: false,
      iamroot: false
    };

    this.openDialog(data);
  }  

  /**
   * Do open the EditArbreComponent with data passed as param
   * @param toPass the data to pass to EditArbreComponent
   */
  openDialog( toPass: any): void {
    const editDiag = this.dialog.open(EditArbreComponent,{
      data: toPass
    });

    editDiag.afterClosed().subscribe(evt=>{
      this.updateTree();
    })
  }

  doShowAll( show: boolean){
    this.showAll = show; //!this.showAll;
    if(!this.showAll){
      this.updateTree();
    }
  }
}
